var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.activeState ? _vm.activeClasses: _vm.inactiveClasses,style:({fontSize: '0.9rem'}),domProps:{"textContent":_vm._s(_vm.activeState ? _vm.activeText: _vm.inactiveText)}})}
var staticRenderFns = []

export { render, staticRenderFns }